export const carUtilization = {
    calendar: undefined,

    init: function () {
        const token = document.head.querySelector("[name~=csrf-token][content]")?.content;

        window.axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': token,
        };

        document.addEventListener('DOMContentLoaded', () => {
            this.initCalendar();
        });
    },

    initCalendar: function () {
        const calendarHolder = document.getElementById('carcalendar');
        if (!calendarHolder) {
            return;
        }

        const elMain = document.querySelector('main');
        const elNav = document.querySelector('nav#app-navbar');
        const navH = elNav.clientHeight + 1;
        const viewportHeight = `calc(100vh - ${navH}px)`;
        elMain.style.height = viewportHeight;

        const container = document.getElementById('CarUtilizationCalContainer');
        if (container) {
            container.style.height = viewportHeight;
        }

        const elCard = calendarHolder.closest('.MunkarendCard, .card');
        if (elCard) {
            elCard.style.height = '100%';
            const cardBody = elCard.querySelector('.card-body');
            if (cardBody) {
                cardBody.style.height = '100%';
            }
        }

        calendarHolder.style.height = '100%';

        this.calendar = new window.Calendar(calendarHolder, {
            height: '100%',
            themeSystem: 'bootstrap',
            plugins: [window.dayGridPlugin, window.timeGridPlugin, window.bootstrapPlugin],
            selectable: false,
            timeZone: 'CET',
            locale: window.huLocale,
            headerToolbar: {
                start: 'dayGridMonth,timeGridWeek,timeGridDay',
                center: 'title',
                end: 'prev,next',
            },
            eventDidMount: function (info) {
                const toolTipStr = `
                    <div class="feladatToolTip">
                        <div><strong>Csapat:</strong> ${info.event.extendedProps.csapat_nev || ''}</div>
                        <div class="feladat">${info.event.extendedProps.napifeladat || ''}</div>
                        <div class="csapattagok">${info.event.extendedProps.users || ''}</div>
                    </div>
                `;
                tippy(info.el, {
                    content: toolTipStr,
                    allowHTML: true,
                });
            },
            events: function (info, successCallback, failureCallback) {
                const params = new URLSearchParams({
                    start: info.startStr,
                    end: info.endStr,
                    timeZone: info.timeZone,
                });

                axios
                    .get(`/munkarendCarsAjax?${params.toString()}`)
                    .then((response) => {
                        successCallback(response.data || []);
                    })
                    .catch((error) => {
                        failureCallback(error);
                    });
            },
        });

        this.calendar.render();
    },
};
